import { createSlice } from "@reduxjs/toolkit";
import {
    getAllEmployeeLeaves, getAllLeaveTypes, getMyLeaves, getAllApplicableLeaveTypes, getRaisedLeavesData, getLeaveRequestsForApprover, getDashboardPendingLeaves, createNewLeaveRequest, approveRequests
} from './thunk';

export const initialState = {
    empLeavesList: [],
    myLeaveList: [],
    leaveTypesList: [],
    applicableLeaveType: [],
    getOnlyRaisedLeavesList: [],
    pendingRequestsForApprover: [],
    approverPendingLastFetchedAt: 0 as number,
    dashboardPendingLeaves: [],
    errors: {}
};

const LeavesSlice = createSlice({
    name: 'Leaves',
    initialState,
    reducers: {},
    extraReducers: (builder) => {
        // List
        builder.addCase(getAllEmployeeLeaves.fulfilled, (state: any, action: any) => {
            state.empLeavesList = action.payload?.data || action.payload || [];
        });
        builder.addCase(getAllEmployeeLeaves.rejected, (state: any, action: any) => {
            state.error = action.payload?.error || action.error?.message || null;
        });
        builder.addCase(getMyLeaves.fulfilled, (state: any, action: any) => {
            state.myLeaveList = action.payload?.data || action.payload || [];
        });
        builder.addCase(getMyLeaves.rejected, (state: any, action: any) => {
            state.error = action.payload?.error || action.error?.message || null;
        });
        builder.addCase(getAllLeaveTypes.fulfilled, (state: any, action: any) => {
            state.leaveTypesList = action.payload?.data || action.payload || [];
        });
        builder.addCase(getAllLeaveTypes.rejected, (state: any, action: any) => {
            state.error = action.payload?.error || action.error?.message || null;
        });
        builder.addCase(getAllApplicableLeaveTypes.fulfilled, (state: any, action: any) => {
            state.applicableLeaveType = action.payload?.data || action.payload || [];
        });
        builder.addCase(getAllApplicableLeaveTypes.rejected, (state: any, action: any) => {
            state.error = action.payload?.error || action.error?.message || null;
        });

         builder.addCase(getRaisedLeavesData.fulfilled, (state: any, action: any) => {
            state.getOnlyRaisedLeavesList = action.payload?.data || action.payload || [];
        });
        builder.addCase(getRaisedLeavesData.rejected, (state: any, action: any) => {
            state.error = action.payload?.error || action.error?.message || null;
        });
        
        // Create new leave request
        builder.addCase(createNewLeaveRequest.fulfilled, (state: any, action: any) => {
            // Clear any previous errors
            state.error = null;
        });
        builder.addCase(createNewLeaveRequest.rejected, (state: any, action: any) => {
            state.error = action.payload?.error || action.error?.message || 'Failed to create leave request';
        });
        
        // Approve requests
        builder.addCase(approveRequests.fulfilled, (state: any, action: any) => {
            // Clear any previous errors
            state.error = null;
        });
        builder.addCase(approveRequests.rejected, (state: any, action: any) => {
            state.error = action.payload?.error || action.error?.message || 'Failed to approve request';
        });
        
        // Leave requests for approver (all statuses)
        builder.addCase(getLeaveRequestsForApprover.fulfilled, (state: any, action: any) => {
            state.pendingRequestsForApprover = action.payload?.data || action.payload || [];
            state.approverPendingLastFetchedAt = Date.now();
        });
        builder.addCase(getLeaveRequestsForApprover.rejected, (state: any, action: any) => {
            state.error = action.payload?.error || action.error?.message || null;
        });
        
        // Dashboard pending leaves
        builder.addCase(getDashboardPendingLeaves.fulfilled, (state: any, action: any) => {
            state.dashboardPendingLeaves = action.payload?.data || action.payload || [];
        });
        builder.addCase(getDashboardPendingLeaves.rejected, (state: any, action: any) => {
            state.error = action.payload?.error || action.error?.message || null;
        });
    }
});

export default LeavesSlice.reducer;